module.exports = __webpack_public_path__ + "img/SMS28290-L-min.3978c445.png";